import React, { useEffect,  } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	useEffect(() => {
		if(client){

		}
	},[dispatch, t, client])

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8}></Col>
                <Col xs={2}></Col>
            </Row>
            <Row>
                <Col>
                    <Link to="/admin/ordersfordelivery" className='btn btn-dashboard btn-dashboard-white'>
                        {t('admin.dashboard.ordersfordelivery')}
                    </Link>
                </Col>
                 <Col>
                    <Link to="/admin/orderspendingpay" className='btn btn-dashboard btn-dashboard-white'>
                        {t('admin.dashboard.orderspendingpay')}
                    </Link>
                </Col>
                <Col>
                    <Link to="/admin/ordersdelivered" className='btn btn-dashboard btn-dashboard-white'>
                        {t('admin.dashboard.ordersdelivered')}
                    </Link>
                </Col>
            </Row>
        </Container>
	)
}